import axios from 'axios';

const getTitle = function() {
  // axios.get('/p/cs/countUsers').then(({data}) => {
  //   console.log('getTitle');
  //   if (data.code == -1) {
  //     let name = 'I love shanghai123'
  //     document.title = name;
  //   }
  // });
};
export default getTitle;
